import React, { useState } from "react";
import { enUS } from "date-fns/locale";
import { Dropdown, Button, Modal } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import { useDispatch } from "react-redux";
import { showErrorDialog } from "./dialog";
import moment from "moment";
import { useForceUpdate } from "./util";
import useIsMounted from "./useIsMounted";
import {
  setEndDateDashboard,
  setStartDateDashboard,
} from "../pages/company/companySlice";
import "./InputDateRange.css"; // Import custom CSS

export const InputDateRange = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  CallApi,
  paramsFilter,
  paramsStart,
  paramsEnd,
  hidden,
}) => {
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const [selectedRange, setSelectedRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isMountedRef = useIsMounted();

  const handleSelect = (ranges) => {
    setSelectedRange([ranges.selection]);
  };

  const handleApply = async (e) => {
    e.stopPropagation();
    const newStartDate = moment(selectedRange[0].startDate).format(
      "YYYY-MM-DD"
    );
    const newEndDate = moment(selectedRange[0].endDate).format("YYYY-MM-DD");

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    console.log(newStartDate, newEndDate, "newStartDate");

    dispatch(setStartDateDashboard(newStartDate));
    dispatch(setEndDateDashboard(newEndDate));

    forceUpdate();

    const params = {
      ...paramsFilter,
      [paramsStart]: moment(selectedRange[0].startDate).format("YYYY-MM-DD"),
      [paramsEnd]: moment(selectedRange[0].endDate).format("YYYY-MM-DD"),
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(CallApi(params));
      if (isMountedRef.current) {
        if (response.payload.data.status_code === 200) {
          // Handle success if needed
        } else {
          showErrorDialog(response.payload.data.message);
        }
      }
    } catch (error) {
      if (isMountedRef.current) {
        showErrorDialog(error.message);
      }
    }

    setIsDropdownOpen(false);
  };

  const handleClear = async (e) => {
    e.stopPropagation();
    setStartDate("");
    setEndDate("");
    forceUpdate();

    const params = {
      ...paramsFilter,
      [paramsStart]: "",
      [paramsEnd]: "",
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(CallApi(params));
      if (isMountedRef.current) {
        if (response.payload.data.status_code === 200) {
          // Handle success if needed
        } else {
          showErrorDialog(response.payload.data.message);
        }
      }
    } catch (error) {
      if (isMountedRef.current) {
        showErrorDialog(error.message);
      }
    }

    setIsDropdownOpen(false);
  };

  return (
    <>
      <Dropdown
        show={isDropdownOpen}
        onToggle={(isOpen) => setIsDropdownOpen(isOpen)}
        className="w-100"
      >
        <Dropdown.Toggle variant="secondary" id="dropdown-basic" block="true">
          {startDate === endDate ? (
            <span
              className="text-dark font-weight-bold"
              id="kt_dashboard_daterangepicker_date"
            >
              {startDate === ""
                ? "DD/MM/YYYY"
                : moment(startDate).format("DD/MM/YYYY")}
            </span>
          ) : (
            <span
              className="text-dark  font-weight-bold"
              id="kt_dashboard_daterangepicker_date"
            >
              {moment(startDate).format("DD/MM/YYYY")} -{" "}
              {moment(endDate).format("DD/MM/YYYY")}
            </span>
          )}
        </Dropdown.Toggle>
      </Dropdown>

      <Modal
        show={isDropdownOpen}
        onHide={() => setIsDropdownOpen(false)}
        centered
        className="modal-fullscreen"
      >
        <Modal.Body>
          <div className="d-flex flex-column">
            <DateRangePicker
              ranges={selectedRange}
              onChange={handleSelect}
              locale={enUS} // Pass the locale to the DateRangePicker component
              className="w-100"
            />
            <div className="d-flex justify-content-between mt-3">
              <Button
                className="mr-3 w-100"
                onClick={(e) => {
                  handleClear(e);
                }}
                hidden={hidden}
                variant="secondary"
              >
                Clear
              </Button>
              <Button
                className="mr-3 w-100"
                onClick={(e) => {
                  handleApply(e);
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
